import { Tabs } from "antd";
import Content from "layouts/agencyPortal/dashboard/content";
import PageLayout from "layouts/agencyPortal/dashboard/pageLayout";
import MergeDebtorsListTab from "features/mergeGroups/components/mergeDebtorsListTab";

const items = [
  {
    key: "1",
    label: "Merge Debtors",
    children: <MergeDebtorsListTab />,
  },
];

function MergeDebtorsPage() {
  return (
    <PageLayout>
      <Content>
        <Tabs defaultActiveKey="1" items={items} />
      </Content>
    </PageLayout>
  );
}

export default MergeDebtorsPage;
